<template lang="pug">
.container
  van-nav-bar(title='审批' left-text='返回' left-arrow @click-left='onClickLeft' )
  van-search(v-model='form.keywords' placeholder='请输入搜索关键词', @input="dressingByScreen", clearable, @clear="searchClearFn")
  van-dropdown-menu
    van-dropdown-item(v-model='form.flowType' title='流程类型' :options='definitionList' @change='dressingByScreen')
    van-dropdown-item(v-model='form.flowInstanceOwnerId' title='申请人' :options='userList' @change='dressingByScreen')
    van-dropdown-item(ref='timeSearch' v-model='form.startDate' title='申请时间')
      div
        van-datetime-picker(v-model='form.startDate' type='date' title='选择年月日' @confirm='dressingByScreen' @cancel="cancelDate")
  .listContainer
    van-list(v-model='loading' :finished='finished' finished-text='没有更多了' @load='onLoad')
      .flowItem(v-for='(item,index) in list' :key='item.businessId' @click='openDetail(item)')
        .title
          h3 {{ item.title }}
          van-tag(round :type='flowStatus[item.status].type') {{ flowStatus[item.status].text }}
        .flowDesc
          span 流程类型：
          span {{ item.flowType }}
        .flowDesc
          span 申请时间：
          span {{ item.createTime }}
        .flowDesc
          span 申请人：
          span {{ item.flowInstanceOwnerName }}
  van-tabbar(v-model='active' @change="dressingByScreen")
    van-tabbar-item(name='pend' icon='todo-list-o') 待处理
    van-tabbar-item(name='finish' icon='certificate') 已处理
    van-tabbar-item(name='copy' icon='friends-o') 抄送我的
</template>
<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { appBackMethods } from "@/CommonDP/pages/appView/utils";
import * as uni from "@/CommonDP/mongeView/appView/component/uni.webview.1.5.2";

function Form() {
  return {
    flowInstanceOwnerId: "",
    startDate: "",
    flowType: "",
    keywords: ""
  };
}
export default {
  data() {
    return {
      active: 'pend',
      flowStatus: {
        1: { text: '已通过', type: 'success' },
        2: { text: '审批中', type: 'warning' },
        3: { text: '已撤回', type: 'danger' },
        0: { text: '已驳回', type: 'danger' }
      },
      finished: false,
      list: [],
      loading: false,
      form: new Form(),
      approvalProjectList: [],
      arrDef: [{
        text: '全部',
        value: ''
      }],
      definitionList: [],
      userList: [],
      page: {
        pageNum: 0,
        pageSize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    ...mapState({
      localPrjId: state => state.projectMg.prjObj?.prjId,
      localEnterpriseId: state => state.enterprise.enterpriseId
    }),
    prjId() {
      return this.$route.query.prjId || this.localPrjId;
    },
    enterpriseId() {
      return this.$route.query.enterpriseId || this.localEnterpriseId;
    },
    formParams() {
      return {
        prjId: this.prjId,
        enterpriseId: this.enterpriseId,
        flowInstanceOwnerId: '',
        approveTime: '',
        flowType: '',
        keywords: '',
        startDate: '',
        endDate: '',
        ...this.form
      };
    }
  },
  mounted() {
    this.getDefinitionList();
    this.getUserList();
  },
  methods: {
    cancelDate() {
      this.$refs.timeSearch.toggle(false);
      this.form.startDate = '';
      this.dressingByScreen();
      this.form.startDate = new Date(2013, 0, 1);
    },
    // 搜索清除图标
    searchClearFn() {
      this.form.keywords = '';
      this.dressingByScreen();
    },
    // 筛选
    dressingByScreen() {
      this.$refs.timeSearch.toggle(false);
      this.list = [];
      this.getList(1);
    },
    onClickLeft() {
      appBackMethods();
    },
    async openDetail(row) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", status } = row;
      let data = { currentVersionId, flowInstanceId, flowKey, approveType: "view", businessId, enterpriseId: this.enterpriseId, isProject: true };
      const statusName = getStatusName(status);
      if (statusName === "审批中") data = { ...data, approveType: "edit" };
      if (statusName === "草稿") data = { ...data, approveType: "draft" };
      const routeUrl = this.$router.resolve({ path: "/flowH5Summary", query: data });
      window.open(routeUrl.href, '_blank');
    },
    onLoad() {
      this.getList();
    },
    async getList(flag) {
      if (flag === 1) {
        this.page.pageNum = 1;
      } else {
        this.page.pageNum++;
      }
      const { page: { pageNum, pageSize }} = this;
      const params = {
        ...this.formParams
      };
      let service;
      if (this.active === 'pend') {
        service = flowService.myProcessing(params, pageNum, pageSize);
      } else if (this.active === 'finish') {
        service = flowService.myProcessed(params, pageNum, pageSize);
      } else {
        service = flowService.cc(params, pageNum, pageSize);
      }
      const { data, pageIndex, totalCount } = await service;
      if (pageIndex !== 1) {
        this.list = [...this.list, ...data];
      } else {
        this.list = data;
      }
      if (pageIndex === (parseInt(totalCount / this.page.pageSize) + 1)) {
        this.finished = true;
      } else {
        this.finished = false;
      }
      this.page.pageNum = pageIndex;
      this.loading = false;
      this.page.totalCount = totalCount;
    },

    // 以下是内部方法
    resetForm() {
      this.form = new Form();
    },
    // 查询流程类型
    async getDefinitionList() {
      const res = await flowService.downList(this.enterpriseId);
      const arr = (res.data || []).map(item => ({ text: item.flowName, value: item.flowDefinitionId }));
      this.definitionList = this.arrDef.concat(arr);
    },
    // 查询申请人
    async getUserList() {
      const res = await flowService.applicant(this.enterpriseId);
      const arr = (res.data || []).map(item => ({ text: item.flowInstanceOwnerName, value: item.flowInstanceOwnerID }));
      this.userList = this.arrDef.concat(arr);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.listContainer {
  overflow: auto;
  // flex: 1 1 auto;
  height: calc(100% - 200px);
  .van-list{
    height: 100%;
  }
}
.flowItem {
  padding: 8px 15px;
  border-bottom: 1px solid #ccc;

  h3 {
    font-size: 15px;
    line-height: 30px;
    font-weight: 700;
    padding-right: 10px;
    display: inline-block;
    white-space:nowrap;
    max-width: calc(100% - 60px);
    overflow-x: auto;
    scrollbar-width: none; /* firefox */
   -ms-overflow-style: none;
  }
  h3::-webkit-scrollbar {
    display: none;
  }
  .van-tag{
    padding: 0 8px;
    line-height: 25px;
  }
  .title {
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .flowDesc {
    font-size: 14px;
  }
}
</style>
